/* eslint-disable no-unused-vars */
import { FC } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/Button";
import { GoArrow } from "@/icons";
import { BookModel } from "@/types";
import { motion } from "framer-motion";

interface BookCardProps {
  index: number;
  book: BookModel;
  handleProductClick: (model: BookModel) => void;
}

const BookCard: FC<BookCardProps> = ({ book, handleProductClick }) => {
  const { t } = useTranslation("translation", { keyPrefix: "bookcard" });

  return (
    <div className="book-card">
      <div className="book-card-detail">
        <div
          onClick={() => handleProductClick(book)}
          className="book-image-container"
        >
          <motion.img
            src={book.coverImageUrl || book.CoverImageUrl}
            alt={book.title}
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          />
        </div>
        <div className="book-info">
          <h2>{book.title}</h2>
          <span>
            {t("lesson")}: {book.lessonNames}
          </span>
          <br />
          <span>
            {t("class")}: {book.classNames}
          </span>
        </div>
      </div>
      <div className="book-card-buttons">
        <Button
          className={`obro-btn w-50 go-book-btn ${book.isGroup ? "obro-primary-btn" : "obro-success-btn"}`}
          onClick={() => handleProductClick(book)}
        >
          <span className="text-white">
            {book.isGroup ? t("group_contents") : t("open_book")}
          </span>
          <GoArrow className={undefined} />
        </Button>
      </div>
    </div>
  );
};

export default BookCard;
